import { render } from "./MaintainancePricing.vue?vue&type=template&id=561cc0d0&scoped=true"
import script from "./MaintainancePricing.vue?vue&type=script&lang=js"
export * from "./MaintainancePricing.vue?vue&type=script&lang=js"

import "./MaintainancePricing.vue?vue&type=style&index=0&id=561cc0d0&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561cc0d0"]])

export default __exports__